import logo from './title1.png';
import WalletConnectButton from './StockItems/WalletConnectButton';
import NormalBtn from './StockItems/NormalBtn';
import {useState} from 'react';
import { Icon } from '@iconify/react';

function App(props) {

  var revertProgramIDFn = props.revertProgramIDFn;
  var addToExtraScreen = props.addToExtraScreen;
  var logInState = props.logInState;
  var logOut = props.logOut;
  var history = props.history;
  var nosCredits = props.nosCredits;

  const [showMenu, setShowMenu] = useState(false);

  var buttonBit;
  var creditsButton;

//

    buttonBit = <li className='nav-item'><WalletConnectButton addToExtraScreen={addToExtraScreen} logInState={logInState} logOut={logOut} /></li>
//
    if (logInState){
      if (history === 'loading'){
      }else{
        function clickCredits(e){
          addToExtraScreen({t:'credits',v:0});
        }
        creditsButton = <li className='nav-item'><NormalBtn title={nosCredits} onClick={clickCredits} icon='ph:coin' iconText='Credits'/></li>

      }
    }

//
  function clickFeedback(e){
    addToExtraScreen({t:'feedback'});
  }

  function toggleMenu(){
    setShowMenu(!showMenu);
  }
  const show = (showMenu) ? 'show' : '' ;

  return <nav className='navbar navbar-expand-lg navbar-custom'>
              <img style={{width:'10rem'}} src={logo} onClick={revertProgramIDFn} alt='alternative'></img>
            
              <button className='navbar-toggler' type='button' onClick={ toggleMenu }>
                <span className='navbar-toggler-icon'><Icon width = '30' icon='eva:menu-outline' /></span>
              </button>
            
                <div className={'collapse navbar-collapse ' + show}>
                    <ul className='navbar-nav ml-auto'>
                        <li className='nav-item dropdown'>
                          <NormalBtn onClick={clickFeedback} title='Feedback' icon='codicon:feedback'/>
                        </li>
                        {creditsButton}
                        {buttonBit}
                      </ul>
                  </div>
            </nav> 

}


export default App;
